define(function (require) {
    var $ = require("jquery");

    $(".interop-create-account").click(function (e) {
        e.preventDefault();
        window.open($(this).attr("href"));
        location.href = $(this).attr("data-returnloginurl");
    });

});
